module.exports = __webpack_public_path__ + "static/media/questions.5f4dc86e.mp3";